import {find} from 'lodash';
import {Component, Fragment} from 'react';
import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import {Grid, Form} from 'semantic-ui-react';
import {Field} from 'apstra-ui-common';
import {computed, makeObservable} from 'mobx';

import IBAContext from '../IBAContext';
import Dashboard from './Dashboard';
import generateDashboardURI from '../generateDashboardURI';
import {PredefinedDashboardIcons} from './PredefinedDashboardIcons';
import UpdatedByLabel from './UpdatedByLabel';
import DashboardCaption from './DashboardCaption';
import DashboardDefaultToggle from './DashboardDefaultToggle';

import './DashboardExpanded.less';

@observer
export default class DashboardExpanded extends Component {
  static contextType = IBAContext;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @computed get predefinedDashboard() {
    return find(this.props.predefinedDashboards, {name: this.props.dashboard.predefined_dashboard});
  }

  renderBreadcrumbSections() {
    const {context: {blueprintId}, props: {dashboard}, predefinedDashboard} = this;

    return [{
      key: 'label',
      active: true,
      content: (
        <Fragment>
          <Link to={generateDashboardURI({blueprintId, dashboardId: dashboard.id})}>{dashboard.label}</Link>
          &nbsp;
          <PredefinedDashboardIcons
            asLabel
            isDashboardInstance
            predefinedDashboard={predefinedDashboard}
          />
          &nbsp;
          <UpdatedByLabel updatedBy={dashboard.updated_by} timestamp={dashboard.updated_at} />
        </Fragment>
      )
    }];
  }

  render() {
    const {
      dashboard, setDashboardDeletionModalProps, setDashboardExportModalProps,
      dashboardIdToggleInProgress, toggleDashboardDefaultFlag
    } = this.props;

    const {predefinedDashboard} = this;

    return (
      <Grid className='iba-dashboard-expanded'>
        <DashboardCaption
          breadcrumbSections={this.renderBreadcrumbSections()}
          dashboard={dashboard}
          predefinedDashboard={predefinedDashboard}
          setDashboardDeletionModalProps={setDashboardDeletionModalProps}
          setDashboardExportModalProps={setDashboardExportModalProps}
          nextToBreadcrumbContent={
            <Form>
              <Field label='Default' inline>
                <DashboardDefaultToggle
                  value={dashboard.default}
                  dashboardIdToggleInProgress={dashboardIdToggleInProgress}
                  onChange={toggleDashboardDefaultFlag}
                />
              </Field>
            </Form>
          }
        />
        <Grid.Row>
          <Grid.Column>
            <Dashboard editable={false} dashboard={dashboard} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
